import * as Yup from 'yup'

export const referenceSchema = Yup.object().shape({
  newReference: Yup.string()
    .transform(val => (val === null ? null : val.trim()))
    .url('Click up ID must be a valid URL like "https://mondra.com"')
    .nullable(true),
})
